import React, {useState} from "react";
import InputForm from "./ComponentesFormularios/InputForm";


const FilterTable = ({tableRef, identificador, className}) => {

  const [state, setState] = useState("");

  const handleChange = ({name, value}) => {
    setState(value);
    tableRef.current.api.setQuickFilter(value);
  }

  return(
    <InputForm identificador={identificador} value={state} label="" placeholder="Buscar..." className={className} style={{marginLeft: 0}}
               handleChange={({name, value}) => handleChange({name, value})}/>
  )

}

export default FilterTable;
